import getters from "./AuthGetters";
import actions from "./AuthActions";
import mutations from "./AuthMutations";

const state = {
    authId: null,
    unsubscribeAuthObserver: null,
    loading: false,
    error: {
        message: null
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
